// extracted by mini-css-extract-plugin
export default {"recos":"E7-z","productCardOverride":"F7-z","rowHasBadge":"G7-z"};